import { render, staticRenderFns } from "./printTemplate.vue?vue&type=template&id=0038390b&scoped=true"
import script from "./printTemplate.vue?vue&type=script&lang=js"
export * from "./printTemplate.vue?vue&type=script&lang=js"
import style0 from "./printTemplate.vue?vue&type=style&index=0&id=0038390b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038390b",
  null
  
)

export default component.exports